export default __webpack_public_path__ + "static/media/Roboto-BoldItalic.7f8b6363.ttf";